import { authenticatedUserSchema } from './authenticated-user.schema';
import { accountRoleSchema } from './account-role.schema';
import { z } from 'zod/v4';

const multiAccountAuthResponseSchema = z.object({
  accounts: z.array(accountRoleSchema),
  status: z.literal('FailedToLoginDueToMultipleAccounts'),
});

const expiredAccountAuthResponseSchema = z.object({
  userInfo: authenticatedUserSchema,
  status: z.literal('FailedToLoginAccountExpired'),
});

const invalidTidTokenAuthResponseSchema = z.object({
  status: z.literal('FailedToValidateTrimbleIdentityToken'),
});

export const authenticateResponseSchema = z.union([
  authenticatedUserSchema,
  multiAccountAuthResponseSchema,
  expiredAccountAuthResponseSchema,
  invalidTidTokenAuthResponseSchema,
]);
